import axios from 'axios';
import { IFinanzamtDto } from '@/shared/model/finanzamt-dto.model';

const baseGemfaApiUrl = 'api/gemfa/finanzamt';

export default class GemfaService {
  public retrieveFinanzamt(plz): Promise<IFinanzamtDto> {
    return new Promise<IFinanzamtDto>((resolve, reject) => {
      axios
        .get(`${baseGemfaApiUrl}/${plz}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
